import { render, staticRenderFns } from "./ln-form-yes-no.vue?vue&type=template&id=89524b66&scoped=true&"
import script from "./ln-form-yes-no.vue?vue&type=script&lang=js&"
export * from "./ln-form-yes-no.vue?vue&type=script&lang=js&"
import style0 from "./ln-form-yes-no.vue?vue&type=style&index=0&id=89524b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89524b66",
  null
  
)

export default component.exports